import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Login from '../../containers/Login';
import Register from '../../containers/Register';
import ResetPassword from '../../containers/ResetPassword';
import ForgotPassword from '../../containers/ForgotPassword';
import VerifyNumber from '../../containers/VerifyNumber';
import VerifyEmail from '../../containers/VerifyEmail';
import Cgu from '../../containers/Cgu';
import Logout from '../../containers/Logout';
import AgentLogin from '../../containers/Agent/AgentLogin';
import PreviewUI from '../../containers/PreviewUI';
import PreviewShell from '../../containers/PreviewShell';

const GeneralRoutes = () => {
  return (
    <Routes>
      <Route path='*' element={
        <Navigate
          to={
            (window.location.pathname !== '/register' &&
              window.location.pathname !== '/forgotpassword' &&
              window.location.pathname !== '/resetpassword' &&
              window.location.pathname !== '/cgu' &&
              window.location.pathname !== '/agent' &&
              window.location.pathname !== '/preview-ui' &&
              window.location.pathname !== '/preview-shell')
              ? "/login"
              : window.location.href
          }
        />
      } />
      <Route path="/login" element={<Login />} />
      <Route path="/agent" element={<AgentLogin />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/verifyNumber" element={<VerifyNumber />} />
      <Route path="/verifyEmail" element={<VerifyEmail />} />
      <Route path="/cgu" element={<Cgu />} />
      <Route path="/preview-ui" element={<PreviewUI />} />
      <Route path="/preview-shell" element={<PreviewShell />} />
    </Routes>
  );
};

export default GeneralRoutes;